/**
 * Query-key factory for the sourcing domain — the single source of truth for every
 * ["sourcing-*"] array (mirrors `studiesKeys` in features/studies/queryKeys.ts).
 */

export const sourcingKeys = {
  lists: ["sourcing-lists"] as const,
  list: (id: string) => ["sourcing-list", id] as const,
  rows: (listId: string) => ["sourcing-rows", listId] as const,
  columnRuns: (listId: string) => ["sourcing-column-runs", listId] as const,
  findRuns: (listId: string) => ["sourcing-find-runs", listId] as const,
};
